import React from "react";

export default function Panchayat() {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>पंचायत विभाग — पंचायत समिती बल्लारपूर</h1>

      {/* प्रस्तावना */}
      <section style={styles.section}>
        <h2 style={styles.heading}>विभागाची प्रस्तावना</h2>
        <p style={styles.text}>
          भारतातील ग्रामीण भागाचा सर्वांगीण विकास साधण्यासाठी व स्थानिक स्वराज्य संस्थांना बळकटी देण्यासाठी पंचायत राज व्यवस्था अस्तित्वात आली आहे.
        </p>
        <p style={styles.text}>
          पंचायत विभागाचा मुख्य उद्देश म्हणजे गावपातळीवर लोकशाही व्यवस्थेला प्रोत्साहन देणे, ग्रामीण जनतेच्या गरजा समजून घेऊन त्यानुसार सेवा पुरवणे आणि विकासात्मक कामकाजात लोकांचा सक्रिय सहभाग वाढवणे.
        </p>
        <p style={styles.text}>
          संविधानाच्या 73व्या घटनादुरुस्तीने पंचायत राज संस्थांना घटनात्मक मान्यता मिळाली असून, गावांच्या सामाजिक, आर्थिक आणि सांस्कृतिक प्रगतीसाठी आवश्यक असे अधिकार व जबाबदाऱ्या पंचायत संस्थांना प्रदान केल्या आहेत.
        </p>
        <p style={styles.text}>
          पंचायत विभाग विविध योजना, कार्यक्रम व उपक्रमांच्या माध्यमातून ग्रामीण भागाचा सर्वांगीण विकास साधण्यासाठी कार्यरत आहे.
        </p>
      </section>

      {/* अधिकारी/कर्मचारी माहिती (Ballarpur साठी रिकामी ठेवली आहे – तुम्ही भरू शकता) */}
      <section style={styles.section}>
        <h2 style={styles.heading}>अधिकारी व कर्मचाऱ्यांची माहिती (बल्लारपूर)</h2>
        <p style={styles.text}>येथे बल्लारपूर पंचायत समितीतील अधिकारी/कर्मचाऱ्यांची माहिती पुढे भरण्यात येईल.</p>
      </section>

      {/* योजना व उपक्रम */}
      <section style={styles.section}>
        <h2 style={styles.heading}>पंचायत विभागाच्या प्रमुख योजना व उपक्रम</h2>
        <ul style={styles.list}>
          <li>अनु.जाती व नवबौद्ध घटकांसाठी वस्ती सुधार कार्यक्रम</li>
          <li>जिल्हा वार्षिक योजना अंतर्गत ग्रामपंचायतींना सहाय्य</li>
          <li>जनसुविधा जिल्हा वार्षिक योजना अंतर्गत विशेष अनुदान</li>
          <li>वसंतराव नाईक तांडा वस्ती सुधार योजना</li>
          <li>15 वा वित्त आयोग — पंचायत स्तरावरील विकास</li>
          <li>अल्पसंख्यांक बहुल क्षेत्र विकास योजना</li>
          <li>प्रधानमंत्री आदर्श ग्राम योजना</li>
          <li>मा. बाळासाहेब ठाकरे मातोश्री ग्रामपंचायत भवन बांधकाम योजना</li>
          <li>दिव्यांग व मागासवर्गीय नागरिकांसाठी विविध लाभ योजना</li>
        </ul>
      </section>

      {/* तक्रार नोंदणी */}
      <section style={styles.section}>
        <h2 style={styles.heading}>तक्रार नोंदणी</h2>
        <p style={styles.text}>तक्रार नोंदणी साठी: <strong>आपले सरकार – तक्रार निवारण प्रणाली</strong></p>
      </section>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    lineHeight: "1.6",
    fontSize: "18px",
  },
  title: {
    fontSize: "30px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "20px",
    color: "#2c3e50",
  },
  section: {
    background: "#f7f7f7",
    padding: "15px",
    borderRadius: "10px",
    marginBottom: "20px",
  },
  heading: {
    fontSize: "22px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#34495e",
  },
  text: {
    marginBottom: "10px",
  },
  list: {
    marginLeft: "20px",
  },
};
